import { createSlice } from "@reduxjs/toolkit";

const formSlice = createSlice({
  name: 'form',
  initialState: {
    numbers: [],
  },
  reducers: {
    updateNumbers: (state, action) => {
      state.numbers = action.payload;
    },
  },
});

export default formSlice;
